<template lang="pug">
.services-menu.row.jc-center.ai-center
  .services-menu__trigger
    img(src="./images/drop-down.svg", alt="")
  ul.services-menu__list
    template(v-for="item in services")
      li.services-menu__item
        a(:href="item.href" :title="item.label[lang]" target="_blank")
          img(:src="item.image", alt="")
          span {{ item.descr[lang] }}

    template(v-for="link in links")
      li.services-menu__link
        a(:href="link.href" target="_blank") {{ link.label[lang] }}
</template>

<script>
export default {
  name: 'ServicesMenu',
  props: {
    exclude: {
      type: String,
      default: '',
      required: false,
    },
    lang: {
      type: String,
      required: false,
      default: 'ru',
    },
    test: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    services: [],
    links: [],
  }),
  mounted() {
    fetch(`https://251805.selcdn.ru/static/services/list${this.test ? '.test' : ''}.json`)
      .then((res) => res.json())
      .then((out) => {
        console.log(this.exclude);
        this.services = out.services.filter((e) => e.key !== this.exclude).filter((e) => e.enable);
        this.links = out.links;
      })
      .catch((e) => {
        global.console.error(e);
      });
  },
};
</script>

<style lang="scss">
$--menu-radius: 3px;
$--menu-shadow: 0px 8px 30px rgba(157, 179, 194, 0.24);
$--menu-transition: all 0.25s ease-in-out;

.services-menu {
  font-family: 'Rubik', sans-serif;
  position: relative;
  &:hover &__list {
    visibility: visible;
    opacity: 1;
    // left: 20px;
    // bottom: -20px;
    transition: $--menu-transition;
  }
  &__trigger {
    margin: 20px;
    width: 17px;
    min-width: 17px;
    max-width: 17px;
    height: 17px;
    min-height: 17px;
    max-height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgb(240, 240, 240);
    transition: $--menu-transition;
    border-radius: 3px;
    img {
      width: 7px;
      height: 4px;
      transition: $--menu-transition;
    }
  }
  &:hover &__trigger {
    border-color: rgb(255, 222, 0);
    img {
      transform: rotate(-180deg);
    }
  }
  &__list {
    min-width: 280 / 16 + rem;
    z-index: 8;
    opacity: 0;
    visibility: hidden;
    transition: all 0.1s ease-in-out;
    list-style: none;
    position: absolute;
    bottom: 0; left: 0;
    // bottom: 0; right: 0;
    border-radius: $--menu-radius;
    box-shadow: $--menu-shadow;
    transform: translate(0, 100%);
    overflow: hidden;
    padding: 0;
    margin: 0;
    background-color: rgb(255, 255, 255);
    // min-width: 360px;
    // max-width: 360px;
  }
  &__link {
    a {
      min-height: auto;
      border-bottom: 1px solid #fff;
      padding: 20px 30px;
      font-size: 14px;
      transition: all 0.25s ease-in-out;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      color: rgb(21, 21, 21);
      text-decoration: none;
      position: relative;
      overflow: hidden;
      &:before {
        content: '';
        left: 50%;
        top: 50%;
        width: 100%;
        height: 100%;
        transform: translate(-50%, -50%);
        position: absolute;
        opacity: 0;
        background: rgb(255, 222, 0);
        z-index: -1;
        transition: all .35s ease-in-out;
      }
      &:hover {
        &:before {
          opacity: 1;
        }
      }
    }
  }
  &__item {
    border-bottom: 1px solid rgb(240, 240, 240);
    &:last-child {
      border-bottom: 0;
    }
    a {
      /* white-space: nowrap; */
      text-decoration: none;
      color: rgb(21, 21, 21);
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 20px 20px 17.5px 20px;
      font-size: 11px;
      transition: $--menu-transition;
      img {
        height: 20px;
        width: auto;
        margin-bottom: 12px;
        transition: $--menu-transition;
        &.place {
          height: 24px;
          margin-bottom: 8px;
        }
        &.skidki {
          margin-left: -5px;
        }
      }
      &:hover {
        background-color: rgb(255, 222, 0);
        img {
          filter: brightness(0) invert(0);
        }
        span {
          color: rgb(21, 21, 21);
        }
      }
    }
  }
}
</style>
